export let hrms12xColumns = () => {
  let indexColumns = [
    {
      key: 'codempid',
      name: '',
      labelCodapp: 'HRMS12X',
      labelIndex: '60',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codempid',
      name: '',
      labelCodapp: 'HRMS12X',
      labelIndex: '70',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codcomp',
      name: '',
      labelCodapp: 'HRMS12X',
      labelIndex: '80',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codpos',
      name: '',
      labelCodapp: 'HRMS12X',
      labelIndex: '90',
      style: 'min-width: 200px;'
    }, {
      key: 'email',
      name: '',
      labelCodapp: 'HRMS12X',
      labelIndex: '150',
      style: 'min-width: 200px;'
    }
  ]

  let notSendColumns = [
    {
      key: 'codempid',
      name: '',
      labelCodapp: 'HRMS12X',
      labelIndex: '60',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codempid',
      name: '',
      labelCodapp: 'HRMS12X',
      labelIndex: '70',
      style: 'min-width: 200px;'
    }, {
      key: 'email',
      name: '',
      labelCodapp: 'HRMS12X',
      labelIndex: '150',
      style: 'min-width: 200px;'
    }
  ]
  return {
    en: {
      index: indexColumns,
      notSend: notSendColumns
    },
    th: {
      index: indexColumns,
      notSend: notSendColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hrms12x.js